export const SET_SHARED_CART = 'sharedCart/SET_SHARED_CART';
export const SET_SHARED_CART_ERROR = 'sharedCart/SET_SHARED_CART_ERROR';
export const SET_IS_REQUEST_PENDING = 'sharedCart/SET_IS_REQUEST_PENDING';
export const SET_IS_LOADED = 'sharedCart/SET_IS_LOADED';
export const SET_CART_HASH = 'sharedCart/SET_CART_HASH';
